import React from "react";
import Section from "Section";
import RUHACKS_LOGO from "./media/ruhackslogo.png";
import COWBOY_EGG from "./media/cowboy_egg.png";
import DESSERT_BACKGROUND from "./media/dessert_bg.jpg";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <Section
      bcolor="#141C29"
      BG={
        <div className="footer-bg">
          <img src={DESSERT_BACKGROUND} alt=""></img>
        </div>
      }
    >
      <div className="footer-con">
        <img src={COWBOY_EGG} alt="" className="footer-cowboyegg" />
        <div className="footer-ab">
          <div className="footer-ab__name">
            <div>
              <img src={RUHACKS_LOGO} alt="" />
            </div>
            <div>RU Hacks</div>
          </div>
          <div className="footer-ab__pages">
            <div>
              <Link
                to=""
                onClick={() => {
                  let about = document.getElementById("about");
                  about &&
                    about.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                }}
              >
                About
              </Link>
            </div>
            <div>
              <Link
                to=""
                onClick={() => {
                  let team = document.getElementById("team");
                  team &&
                    team.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Team
              </Link>
            </div>
            <div>
              <Link
                to=""
                onClick={() => {
                  let faq = document.getElementById("faq");
                  faq &&
                    faq.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                FAQ
              </Link>
            </div>
            <div>
              <Link
                to=""
                onClick={() => {
                  let sponsors = document.getElementById("sponsors");
                  sponsors &&
                    sponsors.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                }}
              >
                Sponsors
              </Link>
            </div>
          </div>
        </div>
        <div className="footer-soc">
          <a href="https://www.facebook.com/ryersonuhacks">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://twitter.com/ryersonuhacks">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://www.instagram.com/ruhacks/">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
        <div className="footer-bottom">
          <div>© RU Hacks 2022</div>
          <a href="mailto:communications@ruhacks.com">
            communications@ruhacks.com
          </a>
          <a href="https://static.mlh.io/docs/mlh-code-of-conduct.pdf">
            MLH Code of Conduct
          </a>
        </div>
      </div>
    </Section>
  );
}
